import { render } from "./Inventario.vue?vue&type=template&id=59446b0c&scoped=true"
import script from "./Inventario.vue?vue&type=script&lang=js"
export * from "./Inventario.vue?vue&type=script&lang=js"

import "./Inventario.vue?vue&type=style&index=0&id=59446b0c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59446b0c"]])

export default __exports__